<template>
    <div class="radio-button-group w-full pt-3 pb-3 items-center text-left">
        <label v-for="(option, index) in options" :key="index" class="inline-flex text-left mr-5 ">
            <input
                :id="option"
                type="radio"
                :name="name"
                class="form-radio mr-1 mt-0.5"
                :checked="modelValue === option"
                v-bind="$attrs"
                @change="$emit('update:modelValue', option)"
                @input="$emit('update:modelValue', option)"
            />
            <span v-if="optionsLabels===null">{{ option }}</span>
            <span v-if="optionsLabels!==null">{{ optionsLabels[index] }}</span>

        </label>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'RadioGroup',
    inheritAttrs: false,
    props: {
        options: {
            required: true,
            type: Array,
        },
        name: {
            required: true,
            type: String,
        },
        optionsLabels: {
            type: Array,
            default: null,
        },
        error: String,
        modelValue: [Number, String],
    },
}
</script>

<style scoped>

</style>